import React from "react";
import {
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalDescription
} from "src/components";

const INVITE_HEADINGS = {
    email: "Email App Invite Successfully Sent!",
    sms: "SMS App Invite Successfully Sent!",
    both: "Email & SMS App Invite Successfully Sent!"
};

const INVITE_DESCRIPTIONS = {
    email: "A personalised email invitation with a unique code has been sent to your selected users so they can join your business app.",
    sms: "A personalised SMS invitation has been sent to your selected users so they can join your business app.",
    both: "Personalised email and SMS invitations have been sent to your selected users so they can join your business app."
};

const InviteSuccessModal = (props) => {
    const { showDialog, handleClose, type, isEitherInviteSuccessful } = props;
    const isSuccessful = Boolean(isEitherInviteSuccessful);

    return (
        <StandardModal
            open={showDialog}
            onClose={() => handleClose(false)}
            title={isSuccessful ? INVITE_HEADINGS[type] : "Invite Failed"}
            widthMode="medium"
            footer={(
                <StandardModalActionGroup $center>
                    <StandardModalActionButton width="8.75rem" onClick={() => handleClose(true)}>
                        Done
                    </StandardModalActionButton>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalDescription>
                {isSuccessful
                    ? INVITE_DESCRIPTIONS[type]
                    : "There was an issue with the invite. Please try again later."}
            </StandardModalDescription>
        </StandardModal>
    );
};

export default InviteSuccessModal;
